# Common Questions

**"Isn't it slow?"**

20-40 tokens/second on M1 — faster than you read

**"What about quality?"**

Great for 80% of daily tasks — refactoring, documentation, learning. Use cloud AI when you need the absolute best

**"How much storage?"**

4-8GB per model — store 5-10 models comfortably on a 256GB machine

**"Does it replace cloud AI?"**

Complements, not replaces. Local for privacy and cost-free iteration, cloud for maximum capability

**"Is setup hard?"**

Install Ollama or LM Studio → Download model → Start using. Under 5 minutes total